export default (imageSrs, sliderId) => {
    console.log(sliderId)
    if (window.location.pathname !== '/register' && window.location.pathname !== '/signin' && window.location.pathname !== '/reset') {
        document.getElementById(sliderId).setAttribute('src', imageSrs);
    }
};
